'use strict';
'use es6';
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/docs/open-source.md
// *****************************************************************************************

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

exports.objectWithoutProperties = objectWithoutProperties;
exports.extends = _extends;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/vendor/canvas/chunk1.js
// module id = 91
// module chunks = 0